module.exports = __webpack_public_path__ + "static/media/laser-training-logo-2.f0a2a66e.png";